<template>
    <van-cell-group>
        <van-field
                v-if="false"
                :value="row.name"
                label="用户名"
                is-link
                input-align="right"
                readonly
                @click="toSetUserName"
        />
        <van-field
                label="登录密码"
                value="*******"
                input-align="right"
                is-link
                readonly
                v-rblink="{name:'UserPassword'}"
        />
        <van-field
                v-if="false"
                input-align="right"
                label="支付密码"
                value="*******"
                is-link
                readonly
                @click="toSetPayPassWord"
        />
        <van-field
                v-if="false" input-align="right" label="绑定手机" placeholder="更换手机" is-link readonly @click="toSetPhone">
            <span slot="label">
                绑定手机
                <br/>
                <span class="van-fields">{{row.phone}}</span>

            </span>
        </van-field>
        <van-field
                v-if="false" input-align="right" is-link readonly @click="toAccount">
            <span slot="label">
                余额
                <br/>
                <span class="van-fields">{{row.balance/100}}</span>
            </span>
        </van-field>
    </van-cell-group>
</template>
<style>
    .van-fields {
        color: #969799;
    }
</style>
<script>

    export default {
        name: 'Setting',

        data: function () {
            return {
                row: {
                    phone: '',
                    name: '',
                    cash: '',
                    balance: '',
                }
            }
        },
        filter: {},
        mounted() {
            document.title='账户设置'
            this.fetch()
        },
        destroyed() {
        },
        methods: {
            fetch() {
                let that = this;
                this.$api.get('/api/user/settingdetail', {}, (res) => {
                    that.row = res.data
                })
            },

            toSetUserName() {
                this.$router.push({name: 'Username'})
            },
            toSetPassWord() {
                this.$router.push({name: 'Password'})
            },
            toSetPayPassWord() {
                this.$router.push({name: 'PayPassword'})
            },
            toSetPhone() {
                this.$router.push({name: 'SetPhone'})
            },
            toAccount() {
                this.$router.push({name: 'CashAccount'})
            }

        }
    }
</script>



// WEBPACK FOOTER //
// Setting.vue?e0481912